import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { SelectInput } from "ra-ui-materialui";
import { Field } from "react-final-form";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "150px auto",
    alignItems: "center",
    marginTop: 15,
    marginBottom: 15,
  },
}));

const SelectInputRA = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography variant="h6">{props.label}</Typography>
      <Field
        {...props}
        label={""}
        name={props.source}
        component={SelectInput}
      />
    </Box>
  );
};

export default SelectInputRA;
